import api from './api';

export const getHolidayCalendars = (params) => api.get('/v1/holiday-calendars', { params });
export const getHolidayCalendar = (id) => api.get(`/v1/holiday-calendars/${id}`);
export const createHolidayCalendar = (data) => api.post('/v1/holiday-calendars', data);
export const updateHolidayCalendar = (id, data) => api.put(`/v1/holiday-calendars/${id}`, data);
export const deleteHolidayCalendar = (id) => api.delete(`/v1/holiday-calendars/${id}`);
export const getHolidays = (id) => api.get(`/v1/holiday-calendars/${id}/holidays`);
export const addHolidays = (id, data) => api.post(`/v1/holiday-calendars/${id}/holidays`, data);
export const deleteHoliday = (holidayId) => api.delete(`/v1/holiday-calendars/holidays/${holidayId}`);
